/**
 * URL参数转换
 * @param params 参数对象
 */
export function transParams(params) {
    let res = ''
    for (const propName of Object.keys(params)) {
        const value = params[propName]
        const part = encodeURIComponent(propName) + "="
        if (value !== null && value !== "" && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== "undefined") {
                        let params = propName + '[' + key + ']'
                        const subPart = encodeURIComponent(params) + "="
                        res += subPart + encodeURIComponent(value[key]) + "&"
                    }
                }
            } else {
                res += part + encodeURIComponent(value) + "&"
            }
        }
    }
    return res
}


/**
 * 路径匹配
 * @param pattern 匹配模式
 * @param path 匹配路径
 */
export function isPathMatch(pattern, path) {
    const regexPattern = pattern.replace(/\//g, '\\/').replace(/\*\*/g, '.*').replace(/\*/g, '[^\\/]*')
    const regex = new RegExp(`^${regexPattern}$`)
    return regex.test(path)
}



